import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Routes } from '../config/routes';
import { LegFiJwtService } from './auth/legfi-jwt.service';

import { JwtLegFiClaims } from './auth/jwt-legfi-claims.model';
import { ApplicationHttpClient } from '../components/shared/http/application-http-client';

@Injectable({
    providedIn: 'root',
})
export class ArchiveService
{
    private _http: ApplicationHttpClient;

    constructor(_http: ApplicationHttpClient) {
        this._http = _http;
    }

    public archiveRecords(organizationId: number, recordType: string, recordIds: number[]): Observable<Object> {
        const jwt: JwtLegFiClaims = LegFiJwtService.read();
        if (jwt === null) {
            return this._http.redirectAndThrow401Observable();
        }

        const url: string = Routes.MakeLegFiCoreUrl(
                Routes.LegFiCore.ArchiveRecords(organizationId || jwt.orgId),
        );

        return this._http.post(url, JSON.stringify({model: recordType, ids: recordIds}));
    }
}
